/** Penolakan sijil tandatangan (planning P4-3b D-583, D-589, D-593): terjemahan sebenar, bukan salinan bahasa Inggeris. */
export default {
  not_home_tenant: 'Sijil tandatangan hanya boleh diurus dan digunakan oleh warga majlis ini.',
  signing_certificate_not_found: 'Sijil tandatangan itu tidak dijumpai. Muat semula senarai.',
  signing_certificate_not_yours:
    'Sijil peribadi itu milik orang lain. Hanya orang yang dinamakan padanya boleh menandatangani dengannya.',
  signing_certificate_unusable: 'Sijil itu tidak boleh menandatangani sekarang.',
  signing_key_unreadable:
    'Kunci persendirian sijil ini tidak dapat dibuka. Kunci penyulitan pemasangan ini mungkin telah bertukar. Keluarkan atau muat naik sijil itu semula.',
  signing_failed: 'gisify tidak dapat menandatangani surat dengan sijil ini.',
  actor_not_permitted: 'Anda tidak dibenarkan berbuat demikian dengan sijil tandatangan.',
  invalid_signing_certificate_request: 'Permintaan itu tidak sah. Semak setiap medan dan cuba lagi.',
  signing_file_too_large:
    'Fail itu terlalu besar. Fail PKCS#12 atau rantaian paling besar 64 KiB, dan kunci paling besar 16 KiB.',
  subject_has_ic_number:
    'Satu nama bagi sijil ini mengandungi sesuatu yang kelihatan seperti nombor kad pengenalan, yang tidak boleh dibawa oleh sijil. Semak nama yang anda taip dan nama majlis pada kepala surat.',
  bound_identity_not_found: 'Orang itu bukan pengguna aktif majlis ini.',
  letterhead_council_missing:
    'Tambah nama majlis pada kepala surat dahulu. Sijil akar mengambil organisasinya daripada nama itu.',
  letterhead_council_too_long:
    'Nama majlis pada kepala surat melebihi 64 aksara, had maksimum bagi sijil. Pendekkan nama itu pada kepala surat dahulu; nama itu tidak akan dipotong.',
  letterhead_council_unwritable:
    'Nama majlis pada kepala surat mengandungi aksara kawalan yang tidak boleh dibawa oleh sijil. Taip semula nama itu pada kepala surat dahulu; gisify tidak akan mengubahnya bagi pihak anda.',
  signing_root_exists: 'Majlis ini sudah mempunyai sijil akar. Padamkannya sebelum mencipta yang lain.',
  signing_root_missing: 'Cipta sijil akar majlis dahulu, dan tunggu sehingga ia sedia.',
  signing_certificates_full: 'Had bilangan sijil tandatangan telah dicapai. Padam sijil yang tidak digunakan lagi.',
  import_rate_limited:
    'Anda telah memuat naik 10 sijil dalam sejam yang lalu, termasuk yang telah dipadam, iaitu had maksimum. Cuba lagi kemudian.',
  signing_certificate_state:
    'Tindakan itu tidak boleh dibuat pada sijil ini sekarang. Sijil yang sedang disediakan tidak boleh dipadam; tunggu sehingga ia sedia atau ditolak.',
  signing_certificate_name_unclear:
    'Sijil ini tidak boleh diluluskan: ia tidak mempunyai tepat satu nama untuk dibandingkan oleh gisify dengan penandatangan.',
  pfx_unreadable: 'Fail PKCS#12 itu tidak dapat dibaca.',
  pfx_password_wrong: 'Kata laluan itu tidak membuka fail ini.',
  pfx_no_integrity:
    'Fail PKCS#12 itu tiada semakan kata laluan, jadi gisify tidak dapat memastikan fail itu lengkap. Eksport semula dengan kata laluan.',
  pem_password_wrong: 'Kata laluan itu tidak membuka kunci ini.',
  key_certificate_mismatch: 'Kunci itu bukan milik sijil dalam fail.',
  certificate_expired: 'Sijil itu telah tamat tempoh.',
  chain_too_long: 'Fail itu mengandungi terlalu banyak sijil. Muat naik sijil dengan rantaian yang lebih pendek.',
  chain_too_large:
    'Sijil dan rantaiannya terlalu besar untuk dimuatkan dalam tandatangan. Muat naik sijil itu dengan rantaian yang lebih pendek.',
  signing_certificate_duplicate: 'Sijil ini sudah ada dalam gisify. Gunakan sijil itu, atau padamkannya dahulu.',
  job_timeout: 'Penyediaan sijil mengambil masa terlalu lama dan telah dihentikan. Cuba lagi.',
  dispatch_failed: 'Penyediaan sijil tidak dapat dimulakan. Cuba lagi.',
  pfx_cipher_unsupported: 'Fail PKCS#12 itu dilindungi dengan kaedah yang tidak diterima oleh gisify.',
  pem_unreadable: 'Fail PEM itu tidak dapat dibaca.',
  key_missing: 'Fail itu tidak mengandungi kunci persendirian.',
  key_more_than_one:
    'Fail itu mengandungi lebih daripada satu kunci persendirian. Muat naik fail yang mengandungi tepat satu.',
  key_algorithm:
    'Jenis atau saiz kunci ini tidak diterima. Gunakan RSA 2048 hingga 8192 bit, atau ECDSA pada P-256, P-384 atau P-521.',
  certificate_usage: 'Sijil itu tidak dibuat untuk menandatangani dokumen.',
  certificate_extension: 'Sijil itu membawa sambungan yang tidak dapat disemak oleh gisify.',
  certificate_encoding: 'Satu sijil dalam fail tidak dikodkan dengan cara piawai.',
  signing_root_inactive: 'Sijil akar majlis belum sedia, jadi tiada sijil boleh dikeluarkan di bawahnya.',
  signing_root_unreadable:
    'Kunci sijil akar majlis tidak dapat dibuka. Kunci penyulitan pemasangan ini mungkin telah bertukar. Padam sijil akar dan cipta yang baharu.',
  generate_failed: 'gisify tidak dapat membuat sijil itu.',
  details: {
    signing_certificate_unusable: {
      disabled: 'Sijil itu dinyahdayakan.',
      deleted: 'Sijil itu telah dipadam.',
      expired: 'Sijil itu telah tamat tempoh.',
      not_yet_valid: 'Sijil itu belum sah.',
      root_inactive: 'Sijil akar majlis yang mengeluarkannya belum sedia.',
    },
    signing_failed: {
      key_mismatch: 'Kunci yang disimpan bukan milik sijil itu.',
      sign_error: 'Penandatanganan terhenti kerana ralat. Cuba lagi, dan beritahu pentadbir jika ia berulang.',
      certificate_changed: 'Tandatangan itu menamakan sijil yang berbeza daripada sijil yang dipilih.',
      too_large: 'Sijil dan rantaiannya terlalu besar untuk dimuatkan dalam tandatangan.',
    },
    pfx_unreadable: {
      ber: 'Strukturnya rosak atau terpotong.',
      shape: 'Ia mengandungi bahagian yang tidak dibaca oleh gisify.',
      too_complex: 'Ia terlalu besar atau bersarang terlalu dalam.',
      iterations: 'Kata laluannya diregangkan lebih banyak kali daripada yang dibenarkan oleh gisify.',
    },
    pfx_cipher_unsupported: {
      rc2_40: 'Ia menggunakan RC2 40-bit. Eksport semula dengan AES-256-CBC, tetapan lalai OpenSSL 3.',
      rc2_128: 'Ia menggunakan RC2 128-bit. Eksport semula dengan AES-256-CBC.',
      rc4_128: 'Ia menggunakan RC4 128-bit. Eksport semula dengan AES-256-CBC.',
      rc4_40: 'Ia menggunakan RC4 40-bit. Eksport semula dengan AES-256-CBC.',
      des2: 'Ia menggunakan Triple DES dua kunci. Eksport semula dengan AES-256-CBC.',
      pbes1: 'Ia menggunakan kaedah PBES1 yang lama. Eksport semula dengan AES-256-CBC.',
      pbes2_cipher: 'Sifirnya bukan AES-CBC; AES-GCM juga tidak diterima. Eksport semula dengan AES-256-CBC.',
      pbmac1: 'Semakan kata laluannya ialah PBMAC1. Eksport semula dengan semakan HMAC-SHA-256.',
      enveloped: 'Ia dikunci kepada sijil, bukan kepada kata laluan. Eksport semula dengan kata laluan.',
      unknown: 'gisify tidak mengenali kaedahnya. Eksport semula dengan AES-256-CBC.',
    },
    pem_unreadable: {
      armour: 'Baris BEGIN dan END tiada atau rosak.',
      legacy_encryption:
        'Kunci itu menggunakan penyulitan OpenSSL yang lama. Tukar kepada PKCS#8 dengan openssl pkcs8 -topk8.',
      not_a_key: 'Blok kunci itu tidak mengandungi kunci persendirian.',
      two_keys: 'Ia mengandungi lebih daripada satu kunci.',
      no_certificate: 'Fail rantaian itu tidak mengandungi sijil.',
    },
    key_algorithm: {
      rsa_small: 'Kunci RSA itu kurang daripada 2048 bit.',
      rsa_large: 'Kunci RSA itu melebihi 8192 bit.',
      curve: 'Lengkung eliptiknya bukan P-256, P-384 atau P-521.',
      rsa_pss: 'Kunci itu hanya boleh digunakan untuk RSA-PSS.',
      ed25519: 'Kunci itu ialah Ed25519.',
      other: 'Kunci itu daripada jenis lain, atau nilainya tidak diterima.',
    },
    certificate_usage: {
      is_ca: 'Ia sijil CA, yang tidak boleh menandatangani surat.',
      key_usage: 'Penggunaan kuncinya tidak membenarkan tandatangan digital.',
      extended_key_usage: 'Penggunaan kunci lanjutannya tidak membenarkan penandatanganan dokumen.',
    },
    certificate_extension: {
      duplicate: 'Ia mengulang satu sambungan.',
      critical_unknown: 'Ia mempunyai sambungan kritikal yang tidak dikenali oleh gisify.',
      constraints: 'Ia membawa kekangan nama atau dasar yang tidak dikuatkuasakan oleh gisify.',
    },
    certificate_encoding: {
      leaf: 'Sijil itu sendiri tidak dalam DER yang ketat.',
      chain: 'Satu sijil dalam rantaian tidak dalam DER yang ketat.',
    },
    generate_failed: {
      internal: 'Berlaku masalah di dalam gisify. Cuba lagi, dan beritahu pentadbir jika ia berulang.',
    },
  },
}
